import { render, staticRenderFns } from "./RelatorioCanceladosList.vue?vue&type=template&id=650c8986"
import script from "./RelatorioCanceladosList.vue?vue&type=script&lang=js"
export * from "./RelatorioCanceladosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports